export default "__VITE_ASSET__85cb82e4__"